import { decode as base64_decode, encode as base64_encode } from "base-64";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { postApi, baseURL } from '../components/Utility'

import Cookies from "js-cookie";
class NotificationStore {
    invoiceDetails = [];
    getClass = [];
    getDriverName = [];
    allCompanyArray = [];

    total = 0;
    loading = false;
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            invoiceDetails: observable,
            getDriverName: observable,
            total: observable,
            loading: observable,
            loadData: action,

        });
        this.rootStore = rootStore;
    }

    async loadData({ offset, limit, companyId, fromDate, toDate, paymentStatus }) {
        this.loading = true;

        var postData = {
            companyId: companyId,
            offset: offset,
            limit: limit,
            page: 1,
            fromDate: fromDate,
            toDate: toDate,
            paymentStatus: paymentStatus
        };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=parent&a=getParentInvoiceDetails",
                "postData=" + base64Input
            );
        this.invoiceDetails = response?.data?.data?.invoiceDatails;
        this.total = response?.data?.data?.TotalCount
        this.loading = false;
    }

    async exportExcel(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=parent&a=exportParentInvoiceDetails&cid=" +
            getData.companyId +
            "&colList=" +
            getData.colList +
            "&fromDate=" +
            getData.fromDate +
            "&toDate=" +
            getData.toDate +
            "&paymentStatus=" +
            getData.paymentStatus +
            "&language=" +
            lang;
    }


}

export default NotificationStore;
